import dayjs from "dayjs";
import { array, date, number, object, string } from "yup";

import { ChartOfAccountTypeEnum } from "@/features/chart-of-accounts";

// Kas/Bank. Cash-to-cash is a transfer, a different document.
export const CASH_BANK_ACCOUNT_TYPES = [ChartOfAccountTypeEnum.CASH_AND_BANK];

// Every account type a disbursement line may hit. Kas & Bank is excluded
// (see above); receivables and payables are excluded because those settle
// through sales and purchase payments, which keep their own allocations.
export const PAYMENT_LINE_ACCOUNT_TYPES = [
  ChartOfAccountTypeEnum.INVENTORY,
  ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
  ChartOfAccountTypeEnum.FIXED_ASSETS,
  ChartOfAccountTypeEnum.ACCUMULATED_DEPRECIATION,
  ChartOfAccountTypeEnum.OTHER_ASSETS,
  ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
  ChartOfAccountTypeEnum.LONG_TERM_LIABILITIES,
  ChartOfAccountTypeEnum.EQUITY,
  ChartOfAccountTypeEnum.REVENUE,
  ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
  ChartOfAccountTypeEnum.EXPENSES,
  ChartOfAccountTypeEnum.OTHER_EXPENSES,
  ChartOfAccountTypeEnum.OTHER_INCOME,
];

export const DEFAULT_VALUES = {
  cashBankOutletChartOfAccount: null,
  transactionDate: dayjs(),
  checkNumber: "",
  payee: "",
  note: "",
  otherPaymentDetails: [],
};

export const VALIDATION_SCHEMA = object().shape({
  cashBankOutletChartOfAccount: object().nullable().required("Harus diisi"),
  transactionDate: date()
    .typeError("Tanggal tidak valid")
    .required("Harus diisi"),
  checkNumber: string().nullable(),
  payee: string().nullable(),
  note: string().nullable(),
  otherPaymentDetails: array()
    .min(1, "Harus memiliki setidaknya satu baris")
    .of(
      object().shape({
        outletChartOfAccount: object().nullable().required("Harus diisi"),
        amount: number()
          .transform((value, originalValue) =>
            originalValue === "" ? undefined : value
          )
          .typeError("Harus berupa angka")
          .required("Harus diisi")
          .moreThan(0, "Harus lebih dari 0"),
        note: string().nullable(),
      })
    ),
});
